var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHclDomino(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 105.31 105.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#12191f;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#93a2ad;}.cls-4{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 52.65,
    x2: 105.31,
    y2: 52.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eea600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#efaa04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#f6c11f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fbd232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#fedc3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdf41"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -788.56,
    y1: -82.51,
    x2: -765.73,
    y2: -82.51,
    gradientTransform: "matrix(1.06, 0.13, -0.11, 0.99, 843.04, 229.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdf41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#fedc3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#fbd232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#f6c11f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#efaa04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eea600"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "HCL_Domino_Master") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4,
    y: 4,
    width: 97.31,
    height: 97.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M101.31,4v97.31H4V4h97.31m0-4H4A4,4,0,0,0,0,4v97.31a4,4,0,0,0,4,4h97.31a4,4,0,0,0,4-4V4a4,4,0,0,0-4-4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "62.72 41.63 49.04 71.89 32.13 72 53.17 25.28 62.72 41.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "90.24 44.45 75.13 78.03 51.37 80.01 76.93 23.26 90.24 44.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "40.47 39.2 29.21 64.22 13.45 62.76 29.78 26.46 40.47 39.2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHclDomino);
export default __webpack_public_path__ + "static/media/hcl-domino.49881f108191507f4acbaa50767f4c55.svg";
export { ForwardRef as ReactComponent };